import script from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=b7e85b26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e85b26"]])

export default __exports__